"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWordDocument = exports.WordDocumentProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useDebounce3 = require("use-debounce");
var _document = require("../utils/document");
var _anchorTrackerRegistry = require("../utils/anchor/anchor-tracker-registry");
var _paragraphBookmarks = require("../utils/paragraph-bookmarks");
var _toast = require("../utils/toast");
var _AnalyticsContext = require("./AnalyticsContext");
var _e2eTestHook = require("../utils/e2e-test-hook");
var _userActivity = require("../utils/user-activity");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t5 in e) "default" !== _t5 && {}.hasOwnProperty.call(e, _t5) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t5)) && (i.get || i.set) ? o(f, _t5, i) : f[_t5] = e[_t5]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  selectedText: null,
  selectedBookmarkNames: [],
  selectedParagraphsUniqueLocalIds: [],
  selectionSource: "API",
  loading: false,
  documentName: null,
  documentLocation: null,
  documentUpdatedAt: Date.now(),
  disableRuleRedirect: false,
  isWriteRestricted: false
};
function documentReducer(state, action) {
  switch (action.type) {
    case "SET_SELECTION":
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, state), action.payload.text !== undefined && {
        selectedText: action.payload.text
      }), action.payload.selectedBookmarkNames !== undefined && {
        selectedBookmarkNames: action.payload.selectedBookmarkNames
      }), action.payload.selectedParagraphsUniqueLocalIds !== undefined && {
        selectedParagraphsUniqueLocalIds: action.payload.selectedParagraphsUniqueLocalIds
      }), {}, {
        selectionOoxmlStripped: action.payload.selectionOoxmlStripped
      });
    case "SET_SELECTION_SOURCE":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectionSource: action.payload.source
      });
    case "SET_LOADING":
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: action.payload
      });
    case "SET_DOCUMENT_UPDATED_AT":
      return _objectSpread(_objectSpread({}, state), {}, {
        documentUpdatedAt: action.payload
      });
    case "SET_DISABLE_RULE_REDIRECT":
      return _objectSpread(_objectSpread({}, state), {}, {
        disableRuleRedirect: action.payload
      });
    case "SET_IS_WRITE_RESTRICTED":
      return _objectSpread(_objectSpread({}, state), {}, {
        isWriteRestricted: action.payload
      });
    default:
      return state;
  }
}
var WordDocumentContext = /*#__PURE__*/(0, _react.createContext)(null);
var WordDocumentProvider = exports.WordDocumentProvider = function WordDocumentProvider(_ref) {
  var _Office$context;
  var children = _ref.children;
  var _useReducer = (0, _react.useReducer)(documentReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    documentState = _useReducer2[0],
    dispatch = _useReducer2[1];
  var selectionSourceRef = (0, _react.useRef)(documentState.selectionSource);
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  (0, _react.useEffect)(function () {
    var _ref2, _documentState$select;
    (0, _e2eTestHook.setE2eSelectionText)((_ref2 = (_documentState$select = documentState.selectionOoxmlStripped) !== null && _documentState$select !== void 0 ? _documentState$select : documentState.selectedText) !== null && _ref2 !== void 0 ? _ref2 : undefined);
  }, [documentState.selectionOoxmlStripped, documentState.selectedText]);
  var setLoading = (0, _react.useCallback)(function (value) {
    return dispatch({
      type: "SET_LOADING",
      payload: value
    });
  }, []);
  var setDisableRuleRedirect = (0, _react.useCallback)(function (disabled) {
    return dispatch({
      type: "SET_DISABLE_RULE_REDIRECT",
      payload: disabled
    });
  }, []);
  var selectBookmark = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(bookmarkName) {
      var _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return (0, _document.withWordContextWrite)(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(context) {
                var bookmarkRange, selection;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      bookmarkRange = context.document.getBookmarkRangeOrNullObject(bookmarkName);
                      bookmarkRange.select();
                      _context.n = 1;
                      return context.sync();
                    case 1:
                      selection = context.document.getSelection();
                      selection.load("text");
                      _context.n = 2;
                      return context.sync();
                    case 2:
                      dispatch({
                        type: "SET_SELECTION_SOURCE",
                        payload: {
                          source: "API"
                        }
                      });
                    case 3:
                      return _context.a(2);
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }());
          case 1:
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t = _context2.v;
            console.warn("Bookmark \"".concat(bookmarkName, "\" not found:"), _t);
            sendError(_t, {
              component: "WordDocumentContext",
              action: "select_bookmark",
              bookmarkName: bookmarkName,
              level: "info"
            });
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [sendError]);
  var documentUrl = (_Office$context = Office.context) === null || _Office$context === void 0 || (_Office$context = _Office$context.document) === null || _Office$context === void 0 ? void 0 : _Office$context.url;
  var documentName = documentUrl === null || documentUrl === void 0 ? void 0 : documentUrl.split('/').pop();
  var documentLocation = documentUrl === null || documentUrl === void 0 ? void 0 : documentUrl.split('/').slice(0, -1).join('/');
  var selectBookmarksRangeIfPresent = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(bookmarkNames) {
      var _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            _context4.n = 1;
            return (0, _document.withWordContextWrite)(/*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(context) {
                var expandedRange;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return (0, _document.getExpandedRangeForBookmarks)(context, bookmarkNames);
                    case 1:
                      expandedRange = _context3.v;
                      if (expandedRange) {
                        _context3.n = 2;
                        break;
                      }
                      return _context3.a(2, false);
                    case 2:
                      expandedRange.select();
                      _context3.n = 3;
                      return context.sync();
                    case 3:
                      dispatch({
                        type: "SET_SELECTION_SOURCE",
                        payload: {
                          source: "API"
                        }
                      });
                      return _context3.a(2, true);
                  }
                }, _callee3);
              }));
              return function (_x4) {
                return _ref6.apply(this, arguments);
              };
            }());
          case 1:
            return _context4.a(2, _context4.v);
          case 2:
            _context4.p = 2;
            _t2 = _context4.v;
            console.error("Failed to select paragraphs with bookmarks:", _t2);
            sendError(_t2, {
              component: "WordDocumentContext",
              action: "select_bookmarks_range",
              bookmarkNames: bookmarkNames
            });
            return _context4.a(2, false);
        }
      }, _callee4, null, [[0, 2]]);
    }));
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }(), [sendError]);
  var selectBookmarksRange = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(bookmarkNames) {
      var selected;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return selectBookmarksRangeIfPresent(bookmarkNames);
          case 1:
            selected = _context5.v;
            if (!selected) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2);
          case 2:
            (0, _toast.toastError)("Changes may have altered this location, we are not able to find it.");
            sendError(new Error("No valid bookmarks found"), {
              component: "WordDocumentContext",
              action: "select_bookmarks_range",
              bookmarkNames: bookmarkNames,
              level: "warning"
            });
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function (_x5) {
      return _ref7.apply(this, arguments);
    };
  }(), [selectBookmarksRangeIfPresent, sendError]);
  (0, _react.useEffect)(function () {
    selectionSourceRef.current = documentState.selectionSource;
  }, [documentState.selectionSource]);

  // Debounce + exclusive lock to prevent concurrent Word.run calls from rapid
  // DocumentSelectionChanged events. On Mac, overlapping getOoxml() calls cause
  // RichApi.Error: GeneralException (WORD-ADDIN-Q). withWordContextWrite ensures
  // only one selection read runs at a time without blocking other read operations.
  // See: https://learn.microsoft.com/en-us/office/dev/add-ins/concepts/correlated-objects-pattern
  (0, _react.useEffect)(function () {
    var SELECTION_DEBOUNCE_MS = 100;
    var debounceTimer = null;
    var processSelectionChange = function processSelectionChange() {
      (0, _document.withWordContextWrite)(/*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(context) {
          var selection, bookmarkNames, selectedParagraphsUniqueLocalIds, selectionOoxmlStripped, ooxml, _t3;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.p = _context6.n) {
              case 0:
                selection = context.document.getSelection();
                selection.load("isEmpty"); // eslint-disable-line office-addins/no-navigational-load
                _context6.n = 1;
                return context.sync();
              case 1:
                if (!selection.isEmpty) {
                  _context6.n = 2;
                  break;
                }
                dispatch({
                  type: "SET_SELECTION",
                  payload: {
                    text: null,
                    selectedBookmarkNames: [],
                    selectedParagraphsUniqueLocalIds: []
                  }
                });
                _context6.n = 8;
                break;
              case 2:
                bookmarkNames = selection.getBookmarks(true, false);
                selection.load("text,paragraphs/items/uniqueLocalId"); // eslint-disable-line office-addins/no-navigational-load
                _context6.n = 3;
                return context.sync();
              case 3:
                selectedParagraphsUniqueLocalIds = [];
                selection.paragraphs.items.forEach(function (paragraph) {
                  selectedParagraphsUniqueLocalIds.push(paragraph.uniqueLocalId);
                });

                // getOoxml() fails with GeneralException for selections containing
                // footnotes, charts, SmartArt, or revision marks. Fetch it in a
                // separate sync so text/bookmarks are always captured on failure.
                _context6.p = 4;
                ooxml = selection.getOoxml();
                _context6.n = 5;
                return context.sync();
              case 5:
                selectionOoxmlStripped = (0, _document.stripBinaryDataFromOoxml)(ooxml.value);
                _context6.n = 7;
                break;
              case 6:
                _context6.p = 6;
                _t3 = _context6.v;
              case 7:
                dispatch({
                  type: "SET_SELECTION",
                  payload: {
                    text: selection.text,
                    selectedBookmarkNames: bookmarkNames.value,
                    selectedParagraphsUniqueLocalIds: selectedParagraphsUniqueLocalIds,
                    selectionOoxmlStripped: selectionOoxmlStripped
                  }
                });
              case 8:
                return _context6.a(2);
            }
          }, _callee6, null, [[4, 6]]);
        }));
        return function (_x6) {
          return _ref8.apply(this, arguments);
        };
      }()).catch(function (err) {
        // Avoid dev overlay crashes from unhandled rejections
        console.warn("SelectionChanged handler error:", err);
        sendError(err, {
          component: "WordDocumentContext",
          action: "handle_document_selection_changed",
          level: "warning"
        });
        dispatch({
          type: "SET_SELECTION",
          payload: {
            text: null,
            selectedBookmarkNames: [],
            selectedParagraphsUniqueLocalIds: []
          }
        });
      });
    };
    var handleDocumentSelectionChanged = function handleDocumentSelectionChanged() {
      (0, _userActivity.reportUserActivity)();
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processSelectionChange, SELECTION_DEBOUNCE_MS);
    };
    if (Office.context.document) {
      Office.context.document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, handleDocumentSelectionChanged);
    }
    processSelectionChange();
    return function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      if (Office.context.document) {
        Office.context.document.removeHandlerAsync(Office.EventType.DocumentSelectionChanged, handleDocumentSelectionChanged);
      }
    };
  }, []);
  var _useState = (0, _react.useState)(initialState.documentUpdatedAt),
    _useState2 = _slicedToArray(_useState, 2),
    documentChangeTimestamp = _useState2[0],
    setDocumentChangeTimestamp = _useState2[1];
  var _useDebounce = (0, _useDebounce3.useDebounce)(documentChangeTimestamp, 2000),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedDocumentChangeTimestamp = _useDebounce2[0];
  var needsBookmarkingRef = (0, _react.useRef)(true);
  var bookmarkingInFlightRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    var handleDocumentChange = function handleDocumentChange(needsBookmarking) {
      if (needsBookmarking) {
        needsBookmarkingRef.current = true;
      }
      setDocumentChangeTimestamp(Date.now());
    };
    return _anchorTrackerRegistry.officeWordDocument.events.subscribe(function (event) {
      if (event.kind === "body_replaced") {
        if (event.phase === "end") handleDocumentChange(true);
        return;
      }
      if (event.kind !== "word_change" || event.change.origin === "remote") return;
      (0, _userActivity.reportUserActivity)();
      handleDocumentChange(event.change.kind === "added" || event.change.kind === "content_control_added");
    });
  }, []);
  (0, _react.useEffect)(function () {
    function startPendingBookmarkingPass() {
      if (!needsBookmarkingRef.current || bookmarkingInFlightRef.current) return;
      needsBookmarkingRef.current = false;
      bookmarkingInFlightRef.current = true;
      (0, _paragraphBookmarks.bookmarkAllParagraphs)().catch(function (error) {
        console.warn("Failed to bookmark paragraphs:", error);
        sendError(error, {
          component: "WordDocumentContext",
          action: "bookmark_all_paragraphs",
          level: "warning"
        });
        (0, _toast.toastWarning)(function () {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: "We weren't able to modify this document's metadata. Some functionalities may not work as expected."
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "text-gray-400 text-sm mt-2",
              children: error.message
            })]
          });
        });
      }).finally(function () {
        bookmarkingInFlightRef.current = false;
        startPendingBookmarkingPass();
      });
    }
    if (debouncedDocumentChangeTimestamp !== null) {
      dispatch({
        type: "SET_DOCUMENT_UPDATED_AT",
        payload: debouncedDocumentChangeTimestamp
      });
      startPendingBookmarkingPass();
    }
    var checkWriteRestriction = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var isRestricted, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return (0, _document.isDocumentWriteRestricted)();
            case 1:
              isRestricted = _context7.v;
              dispatch({
                type: "SET_IS_WRITE_RESTRICTED",
                payload: isRestricted
              });
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t4 = _context7.v;
              console.warn("Failed to check document write restriction:", _t4);
              sendError(_t4, {
                component: "WordDocumentContext",
                action: "check_write_restriction",
                level: "warning"
              });
            case 3:
              return _context7.a(2);
          }
        }, _callee7, null, [[0, 2]]);
      }));
      return function checkWriteRestriction() {
        return _ref9.apply(this, arguments);
      };
    }();
    checkWriteRestriction();
  }, [debouncedDocumentChangeTimestamp, sendError]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(WordDocumentContext.Provider, {
    value: _objectSpread(_objectSpread({}, documentState), {}, {
      documentName: documentName,
      documentLocation: documentLocation,
      selectBookmark: selectBookmark,
      selectBookmarksRange: selectBookmarksRange,
      selectBookmarksRangeIfPresent: selectBookmarksRangeIfPresent,
      loading: documentState.loading,
      setLoading: setLoading,
      setDisableRuleRedirect: setDisableRuleRedirect
    }),
    "data-sentry-element": "WordDocumentContext.Provider",
    "data-sentry-component": "WordDocumentProvider",
    "data-sentry-source-file": "WordDocumentContext.tsx",
    children: children
  });
};
var useWordDocument = exports.useWordDocument = function useWordDocument() {
  var context = (0, _react.useContext)(WordDocumentContext);
  if (!context) {
    throw new Error("useWordDocument must be used within a WordDocumentProvider");
  }
  return context;
};